module.exports = __webpack_public_path__ + "img/h5-基础能力.4f6f5819.svg";